import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=c08f8ae2&scoped=true&"
var script = {}
import style0 from "./notice.vue?vue&type=style&index=0&id=c08f8ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08f8ae2",
  null
  
)

component.options.__file = "notice.vue"
export default component.exports